import React from 'react'
import { styled } from '@mui/material/styles'
import { Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material/'
import { StyledTh } from '@components/atoms/StyledTh'
import { TablePaper } from '@components/atoms/TablePaper'
import { CompanyInfoFragment } from '@services/cloud/client'

const PREFIX = 'CompanyInfoView'

const classes = {
  url: `${PREFIX}-url`,
}

const StyledStyledTh = styled(StyledTh)(() => ({
  [`& .${classes.url}`]: {
    wordBreak: 'break-all',
  },
}))

type Props = {
  company: CompanyInfoFragment
}

const CompanyInfoView = (props: Props) => (
  <StyledStyledTh>
    <TableContainer component={TablePaper}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              企業名
            </TableCell>
            <TableCell>
              <Typography>{props.company.name}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              URL
            </TableCell>
            <TableCell>
              <a href={props.company.url as string}>
                <Typography className={classes.url}>{props.company.url}</Typography>
              </a>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              詳細
            </TableCell>
            <TableCell>
              <Typography>{props.company.description}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  </StyledStyledTh>
)

export default CompanyInfoView
